package dev.kuml.portal.web.util

/**
 * Pure string-slicing helper over the ISO-8601 instant strings `kuml-portal-server` sends for
 * `createdAt`/`updatedAt` (`kotlin.time.Instant.toString()`, e.g.
 * `"2026-07-23T14:07:32.123456789Z"`, always UTC). No `kotlinx-datetime` dependency needed for the
 * small formatting job the project list needs (mustFix 3's "volle Erstellungs-Uhrzeit" guarantee).
 * The ordinary "Zuletzt geändert" date used to live here too as `dateOnly`, hardcoded to the
 * German `"DD.MM.YYYY"` shape -- removed with R-18, superseded by [dev.kuml.portal.web.i18n.format.LocaleFormat.date],
 * which formats correctly for both supported languages.
 */
public object DateFormat {
    /** `"HH:mm"` substring, e.g. `"14:07"` -- used for the default-named-project metaline
     * guarantee (mustFix 3) so two "Unbenanntes Projekt" cards are never visually identical. */
    public fun timeOfDay(isoInstant: String): String? {
        val tIndex = isoInstant.indexOf('T')
        if (tIndex < 0 || isoInstant.length < tIndex + 6) return null
        return isoInstant.substring(tIndex + 1, tIndex + 6)
    }
}
